import './homely.css';

import { Link } from 'react-router-dom'
import { useContext, useEffect, useState } from 'react';
import axios from 'axios';

import articleContext from './articlecontext';
export default function Home() {
    const [artdata, setArtdata] = useContext(articleContext)
    const [artdataf, setArtdataf] = useState([])
    useEffect(() => {
        const fetchdata = async () => {
            try {
                const data = await axios.get('https://dojma-website-2pip.onrender.com/data')
                // console.log(data.data[0].name)
                setArtdata(data.data.slice().reverse());
                setArtdataf(artdata.filter((item) => { return (!item.opinion?.toLowerCase().includes("acadassoc") && !item.opinion?.toLowerCase().includes("csa")) }))

            } catch (error) {
                console.log(error)
            }
        }
        if (!artdata || artdata.length === 0) { fetchdata() }
    }, []);
    useEffect(() => {
        if (artdata && artdata.length > 0) {
            setArtdataf(artdata.filter((item) => { return (!item.opinion?.toLowerCase().includes("acadassoc") && !item.opinion?.toLowerCase().includes("csa")) }))
        }
    }, [artdata]);
    if (!artdataf || artdataf.length === 0) {
        return <div>Loading...</div>; // or a spinner
    }
    else {
        return (
            <>
                <div className='pager'>
                    <div className='page'>
                        <div className="firstcol">
                            <Link to={`/article/${artdata.indexOf(artdataf[1])}`} className="firstart">
                                <div className="topic">
                                    {artdataf[1].opinion}
                                </div>
                                <h3 className="heading">
                                    {artdataf[1].title}
                                </h3>
                                {artdataf[1]?.image && <img className='img1' src={artdataf[1]?.image} />}
                                <div className='deets'>
                                    <div className='date'>
                                        {artdataf[1].date}
                                    </div>
                                    <div className='timeread'>
                                        {
                                            Math.ceil((artdataf[1].body ? artdataf[1].body.split(/\s+/).length : 1) / 200)
                                        } min read
                                    </div>
                                </div>
                                <h4 className="body">
                                    {artdataf[1].body}

                                </h4>
                            </Link>
                            <Link to={`/article/${artdata.indexOf(artdataf[2])}`} className='firstart sec'>
                                <h2 className="topic">
                                    {artdataf[2].opinion}

                                </h2>
                                <h3 className="heading">
                                    {artdataf[2].title}
                                </h3>
                                {artdataf[2]?.image && <img className='img2' src={artdataf[2]?.image} />}
                                <div className='deets'>
                                    <div className='date'>
                                        {artdataf[2].date}
                                    </div>
                                    <div className='timeread'>
                                        {Math.ceil((artdataf[2].body ? artdataf[2].body.split(/\s+/).length : 1) / 200)} min read
                                    </div>
                                </div>
                                <h4 className="body">
                                    {artdataf[2].body}
                                </h4>
                            </Link>
                        </div>
                        <Link to={`/article/${artdata.indexOf(artdataf[0])}`} className="seccol">

                            {artdataf[0]?.image && <img className='img3' src={artdataf[0]?.image} />}
                            <div className='deets'>
                                <div className='date'>
                                    {artdataf[0].date}
                                </div>
                                <div className='timeread'>
                                    {Math.ceil((artdataf[0].body ? artdataf[0].body.split(/\s+/).length : 1) / 200)} min read
                                </div>
                            </div>
                            <h3 className="heading nat">
                                {artdataf[0].title}
                            </h3>
                            <div className="bodysec nat">
                                {artdataf[0].body}
                                <br /><br /><br /><br />
                            </div>


                        </Link>
                        <div className="thirdcol">
                            <Link to={`/article/${artdata.indexOf(artdataf[3])}`} className="firstart">
                                <h2 className="topic">
                                    {artdataf[3].opinion}
                                </h2>
                                <h3 className="heading">
                                    {artdataf[3].title}
                                </h3>
                                {artdataf[3]?.image && <img className='img4' src={artdataf[3]?.image} />}
                                <div><div className='deets'>
                                    <div className='date'>
                                        {artdataf[3].date}<span></span>
                                    </div>
                                    <div className='timeread'>
                                        {Math.ceil((artdataf[3].body ? artdataf[3].body.split(/\s+/).length : 1) / 200)} min read
                                    </div></div>

                                </div>
                                <h4 className="body">
                                    {artdataf[3].body}
                                </h4>
                            </Link>
                            <Link to={`/article/${artdata.indexOf(artdataf[4])}`} className='firstart sec'>
                                <h2 className="topic">
                                    {artdataf[4].opinion}
                                </h2>
                                <h3 className="heading">
                                    {artdataf[4].title}
                                </h3>
                                {artdataf[4]?.image && <img className='img5' src={artdataf[4]?.image} />}
                                <div className='deets'>
                                    <div className='date'>
                                        {artdataf[4].date}{' '}
                                    </div>
                                    <div className='timeread'>
                                        {Math.ceil((artdataf[4].body ? artdataf[4].body.split(/\s+/).length : 1) / 200)} min read
                                    </div>
                                </div>
                                <h4 className="body">
                                    {artdataf[4].body}
                                </h4>
                            </Link>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
